<div class="flex-direction-column gap-5">
  @if (label) {
    <span class="campo-label">{{ label }}</span>
  }

  @if (somenteLeitura) {
    <span class="campo-valor-leitura">{{ textoSomenteLeitura }}</span>
  } @else {
  <div class="campo-select-container">
    <button type="button" class="campo-input-base campo-select-toggle" [class.campo-input-erro]="erro"
            [disabled]="disabled || carregando" (click)="alternar()">
      @if (carregando) {
        <span class="campo-select-skeleton-valor skeleton"></span>
      } @else {
        <span class="campo-select-valor" [class.campo-select-placeholder]="!temValor">
          {{ textoExibicao }}
        </span>
        <mat-icon class="campo-select-seta" [class.campo-select-seta-aberta]="aberto()">expand_more</mat-icon>
      }
    </button>

    @if (aberto()) {
      <div class="campo-select-painel">
        @if (habilitarBusca) {
          <input class="campo-select-busca" type="text" placeholder="Pesquisar" [(ngModel)]="filtro" autocomplete="off" />
        }

        <div class="campo-select-opcoes">
          @if (carregando) {
            @for (i of [1, 2, 3]; track i) {
              <div class="campo-skeleton-linha skeleton"></div>
            }
          } @else if (listaFiltrada.length === 0) {
            <span class="campo-select-vazio">Nenhum resultado encontrado.</span>
          } @else {
            @if (multiplo && opcaoTodos && !filtro) {
              <button type="button" class="campo-select-opcao campo-select-opcao-todos" [class.campo-select-opcao-ativa]="todosSelecionados"
                      (click)="alternarTodos()">
                <span class="campo-select-checkbox" [class.campo-select-checkbox-marcado]="todosSelecionados">
                  @if (todosSelecionados) {
                    <mat-icon>check</mat-icon>
                  }
                </span>
                {{ labelTodos }}
              </button>
            }
            @for (item of listaFiltrada; track item) {
              <button type="button" class="campo-select-opcao" [class.campo-select-opcao-ativa]="ehSelecionado(item)"
                      (click)="selecionar(item)">
                @if (multiplo) {
                  <span class="campo-select-checkbox" [class.campo-select-checkbox-marcado]="ehSelecionado(item)">
                    @if (ehSelecionado(item)) {
                      <mat-icon>check</mat-icon>
                    }
                  </span>
                }
                {{ getDisplayText(item) }}
              </button>
            }
          }
        </div>
      </div>
    }
  </div>
  }

  @if (erro) {
    <span class="campo-erro-texto">{{ erro }}</span>
  }
</div>
